import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
type BreadcrumbItem = {
  label: string;
  onClick?: () => void;
};
type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};
export function Breadcrumbs({
  items
}: BreadcrumbsProps) {
  return <nav className="flex items-center gap-2 text-sm mb-6" data-id="element-47">
      <button onClick={items[0]?.onClick} className="text-gray-600 hover:text-gray-900 transition-colors" data-id="element-48">
        <Home className="w-4 h-4" data-id="element-49" />
      </button>

      {items.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-50">
          <ChevronRight className="w-4 h-4 text-gray-400" data-id="element-51" />
          {index === items.length - 1 ? <span className="font-medium text-gray-900" data-id="element-52">{item.label}</span> : <button onClick={item.onClick} className="text-gray-600 hover:text-gray-900 transition-colors" data-id="element-53">
              {item.label}
            </button>}
        </div>)}
    </nav>;
}